import React from "react";
import { useState, useEffect } from "react";
import { Settings } from "@material-ui/icons";
import { Card, Button, Container, Row, Col, Form } from "react-bootstrap";
import Select from 'react-select';
import { ZOHO } from "../App";
import { Module } from "../App";
import {
  Accounts_City,
  Accounts_Country,
  Accounts_State,
  Accounts_Street,
  Accounts_Zip_Code,
  Accounts_Street_Number,
  Accounts_Latitude,
  Accounts_Longitude,
  Accounts_Neighborhood,
} from "../App";
import {
  Contacts_City,
  Contacts_Country,
  Contacts_State,
  Contacts_Street,
  Contacts_Zip_Code,
  Contacts_Street_Number,
  Contacts_Latitude,
  Contacts_Longitude,
  Contacts_Neighborhood,
} from "../App";
import {
  Leads_City,
  Leads_Country,
  Leads_State,
  Leads_Street,
  Leads_Zip_Code,
  Leads_Street_Number,
  Leads_Latitude,
  Leads_Longitude,
  Leads_Neighborhood,
} from "../App";
import {
  CustomModule1_ApiName,
  CustomModule1_City,
  CustomModule1_Country,
  CustomModule1_State,
  CustomModule1_Street,
  CustomModule1_Zip_Code,
  CustomModule1_Street_Number,
  CustomModule1_StreetFull,
  CustomModule1_Latitude,
  CustomModule1_Longitude,
  CustomModule1_Neighborhood,
} from "../App";
import {
  CustomModule2_ApiName,
  CustomModule2_City,
  CustomModule2_Country,
  CustomModule2_State,
  CustomModule2_Street,
  CustomModule2_Zip_Code,
  CustomModule2_Street_Number,
  CustomModule2_StreetFull,
  CustomModule2_Latitude,
  CustomModule2_Longitude,
  CustomModule2_Neighborhood,
} from "../App";
// import {defaultcountry} from '../App';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapLocationDot, faFlag } from "@fortawesome/free-solid-svg-icons";
import "../style/autoaddress.css";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";

//country list here
const CountryList = [
  { name: "Afghanistan", code: "AF" },
  { name: "Åland Islands", code: "AX" },
  { name: "Albania", code: "AL" },
  { name: "Algeria", code: "DZ" },
  { name: "American Samoa", code: "AS" },
  { name: "AndorrA", code: "AD" },
  { name: "Angola", code: "AO" },
  { name: "Anguilla", code: "AI" },
  { name: "Antarctica", code: "AQ" },
  { name: "Antigua and Barbuda", code: "AG" },
  { name: "Argentina", code: "AR" },
  { name: "Armenia", code: "AM" },
  { name: "Aruba", code: "AW" },
  { name: "Australia", code: "AU" },
  { name: "Austria", code: "AT" },
  { name: "Azerbaijan", code: "AZ" },
  { name: "Bahamas", code: "BS" },
  { name: "Bahrain", code: "BH" },
  { name: "Bangladesh", code: "BD" },
  { name: "Barbados", code: "BB" },
  { name: "Belarus", code: "BY" },
  { name: "Belgium", code: "BE" },
  { name: "Belize", code: "BZ" },
  { name: "Benin", code: "BJ" },
  { name: "Bermuda", code: "BM" },
  { name: "Bhutan", code: "BT" },
  { name: "Bolivia", code: "BO" },
  { name: "Bosnia and Herzegovina", code: "BA" },
  { name: "Botswana", code: "BW" },
  { name: "Bouvet Island", code: "BV" },
  { name: "Brazil", code: "BR" },
  { name: "British Indian Ocean Territory", code: "IO" },
  { name: "Brunei Darussalam", code: "BN" },
  { name: "Bulgaria", code: "BG" },
  { name: "Burkina Faso", code: "BF" },
  { name: "Burundi", code: "BI" },
  { name: "Cambodia", code: "KH" },
  { name: "Cameroon", code: "CM" },
  { name: "Canada", code: "CA" },
  { name: "Cape Verde", code: "CV" },
  { name: "Cayman Islands", code: "KY" },
  { name: "Central African Republic", code: "CF" },
  { name: "Chad", code: "TD" },
  { name: "Chile", code: "CL" },
  { name: "China", code: "CN" },
  { name: "Christmas Island", code: "CX" },
  { name: "Cocos (Keeling) Islands", code: "CC" },
  { name: "Colombia", code: "CO" },
  { name: "Comoros", code: "KM" },
  { name: "Congo", code: "CG" },
  { name: "Congo, The Democratic Republic of the", code: "CD" },
  { name: "Cook Islands", code: "CK" },
  { name: "Costa Rica", code: "CR" },
  { name: "Cote D'Ivoire", code: "CI" },
  { name: "Croatia", code: "HR" },
  { name: "Cuba", code: "CU" },
  { name: "Cyprus", code: "CY" },
  { name: "Czech Republic", code: "CZ" },
  { name: "Denmark", code: "DK" },
  { name: "Djibouti", code: "DJ" },
  { name: "Dominica", code: "DM" },
  { name: "Dominican Republic", code: "DO" },
  { name: "Ecuador", code: "EC" },
  { name: "Egypt", code: "EG" },
  { name: "El Salvador", code: "SV" },
  { name: "Equatorial Guinea", code: "GQ" },
  { name: "Eritrea", code: "ER" },
  { name: "Estonia", code: "EE" },
  { name: "Ethiopia", code: "ET" },
  { name: "Falkland Islands (Malvinas)", code: "FK" },
  { name: "Faroe Islands", code: "FO" },
  { name: "Fiji", code: "FJ" },
  { name: "Finland", code: "FI" },
  { name: "France", code: "FR" },
  { name: "French Guiana", code: "GF" },
  { name: "French Polynesia", code: "PF" },
  { name: "French Southern Territories", code: "TF" },
  { name: "Gabon", code: "GA" },
  { name: "Gambia", code: "GM" },
  { name: "Georgia", code: "GE" },
  { name: "Germany", code: "DE" },
  { name: "Ghana", code: "GH" },
  { name: "Gibraltar", code: "GI" },
  { name: "Greece", code: "GR" },
  { name: "Greenland", code: "GL" },
  { name: "Grenada", code: "GD" },
  { name: "Guadeloupe", code: "GP" },
  { name: "Guam", code: "GU" },
  { name: "Guatemala", code: "GT" },
  { name: "Guernsey", code: "GG" },
  { name: "Guinea", code: "GN" },
  { name: "Guinea-Bissau", code: "GW" },
  { name: "Guyana", code: "GY" },
  { name: "Haiti", code: "HT" },
  { name: "Heard Island and Mcdonald Islands", code: "HM" },
  { name: "Holy See (Vatican City State)", code: "VA" },
  { name: "Honduras", code: "HN" },
  { name: "Hong Kong", code: "HK" },
  { name: "Hungary", code: "HU" },
  { name: "Iceland", code: "IS" },
  { name: "India", code: "IN" },
  { name: "Indonesia", code: "ID" },
  { name: "Iran, Islamic Republic Of", code: "IR" },
  { name: "Iraq", code: "IQ" },
  { name: "Ireland", code: "IE" },
  { name: "Isle of Man", code: "IM" },
  { name: "Israel", code: "IL" },
  { name: "Italy", code: "IT" },
  { name: "Jamaica", code: "JM" },
  { name: "Japan", code: "JP" },
  { name: "Jersey", code: "JE" },
  { name: "Jordan", code: "JO" },
  { name: "Kazakhstan", code: "KZ" },
  { name: "Kenya", code: "KE" },
  { name: "Kiribati", code: "KI" },
  { name: "Korea, Democratic People'S Republic of", code: "KP" },
  { name: "Korea, Republic of", code: "KR" },
  { name: "Kuwait", code: "KW" },
  { name: "Kyrgyzstan", code: "KG" },
  { name: "Lao People'S Democratic Republic", code: "LA" },
  { name: "Latvia", code: "LV" },
  { name: "Lebanon", code: "LB" },
  { name: "Lesotho", code: "LS" },
  { name: "Liberia", code: "LR" },
  { name: "Libyan Arab Jamahiriya", code: "LY" },
  { name: "Liechtenstein", code: "LI" },
  { name: "Lithuania", code: "LT" },
  { name: "Luxembourg", code: "LU" },
  { name: "Macao", code: "MO" },
  { name: "Macedonia, The Former Yugoslav Republic of", code: "MK" },
  { name: "Madagascar", code: "MG" },
  { name: "Malawi", code: "MW" },
  { name: "Malaysia", code: "MY" },
  { name: "Maldives", code: "MV" },
  { name: "Mali", code: "ML" },
  { name: "Malta", code: "MT" },
  { name: "Marshall Islands", code: "MH" },
  { name: "Martinique", code: "MQ" },
  { name: "Mauritania", code: "MR" },
  { name: "Mauritius", code: "MU" },
  { name: "Mayotte", code: "YT" },
  { name: "Mexico", code: "MX" },
  { name: "Micronesia, Federated States of", code: "FM" },
  { name: "Moldova, Republic of", code: "MD" },
  { name: "Monaco", code: "MC" },
  { name: "Mongolia", code: "MN" },
  { name: "Montserrat", code: "MS" },
  { name: "Morocco", code: "MA" },
  { name: "Mozambique", code: "MZ" },
  { name: "Myanmar", code: "MM" },
  { name: "Namibia", code: "NA" },
  { name: "Nauru", code: "NR" },
  { name: "Nepal", code: "NP" },
  { name: "Netherlands", code: "NL" },
  { name: "Netherlands Antilles", code: "AN" },
  { name: "New Caledonia", code: "NC" },
  { name: "New Zealand", code: "NZ" },
  { name: "Nicaragua", code: "NI" },
  { name: "Niger", code: "NE" },
  { name: "Nigeria", code: "NG" },
  { name: "Niue", code: "NU" },
  { name: "Norfolk Island", code: "NF" },
  { name: "Northern Mariana Islands", code: "MP" },
  { name: "Norway", code: "NO" },
  { name: "Oman", code: "OM" },
  { name: "Pakistan", code: "PK" },
  { name: "Palau", code: "PW" },
  { name: "Palestinian Territory, Occupied", code: "PS" },
  { name: "Panama", code: "PA" },
  { name: "Papua New Guinea", code: "PG" },
  { name: "Paraguay", code: "PY" },
  { name: "Peru", code: "PE" },
  { name: "Philippines", code: "PH" },
  { name: "Pitcairn", code: "PN" },
  { name: "Poland", code: "PL" },
  { name: "Portugal", code: "PT" },
  { name: "Puerto Rico", code: "PR" },
  { name: "Qatar", code: "QA" },
  { name: "Reunion", code: "RE" },
  { name: "Romania", code: "RO" },
  { name: "Russian Federation", code: "RU" },
  { name: "RWANDA", code: "RW" },
  { name: "Saint Helena", code: "SH" },
  { name: "Saint Kitts and Nevis", code: "KN" },
  { name: "Saint Lucia", code: "LC" },
  { name: "Saint Pierre and Miquelon", code: "PM" },
  { name: "Saint Vincent and the Grenadines", code: "VC" },
  { name: "Samoa", code: "WS" },
  { name: "San Marino", code: "SM" },
  { name: "Sao Tome and Principe", code: "ST" },
  { name: "Saudi Arabia", code: "SA" },
  { name: "Senegal", code: "SN" },
  { name: "Serbia and Montenegro", code: "CS" },
  { name: "Seychelles", code: "SC" },
  { name: "Sierra Leone", code: "SL" },
  { name: "Singapore", code: "SG" },
  { name: "Slovakia", code: "SK" },
  { name: "Slovenia", code: "SI" },
  { name: "Solomon Islands", code: "SB" },
  { name: "Somalia", code: "SO" },
  { name: "South Africa", code: "ZA" },
  { name: "South Georgia and the South Sandwich Islands", code: "GS" },
  { name: "Spain", code: "ES" },
  { name: "Sri Lanka", code: "LK" },
  { name: "Sudan", code: "SD" },
  { name: "Suriname", code: "SR" },
  { name: "Svalbard and Jan Mayen", code: "SJ" },
  { name: "Swaziland", code: "SZ" },
  { name: "Sweden", code: "SE" },
  { name: "Switzerland", code: "CH" },
  { name: "Syrian Arab Republic", code: "SY" },
  { name: "Taiwan, Province of China", code: "TW" },
  { name: "Tajikistan", code: "TJ" },
  { name: "Tanzania, United Republic of", code: "TZ" },
  { name: "Thailand", code: "TH" },
  { name: "Timor-Leste", code: "TL" },
  { name: "Togo", code: "TG" },
  { name: "Tokelau", code: "TK" },
  { name: "Tonga", code: "TO" },
  { name: "Trinidad and Tobago", code: "TT" },
  { name: "Tunisia", code: "TN" },
  { name: "Turkey", code: "TR" },
  { name: "Turkmenistan", code: "TM" },
  { name: "Turks and Caicos Islands", code: "TC" },
  { name: "Tuvalu", code: "TV" },
  { name: "Uganda", code: "UG" },
  { name: "Ukraine", code: "UA" },
  { name: "United Arab Emirates", code: "AE" },
  { name: "United Kingdom", code: "GB" },
  { name: "United States", code: "US" },
  { name: "United States Minor Outlying Islands", code: "UM" },
  { name: "Uruguay", code: "UY" },
  { name: "Uzbekistan", code: "UZ" },
  { name: "Vanuatu", code: "VU" },
  { name: "Venezuela", code: "VE" },
  { name: "Viet Nam", code: "VN" },
  { name: "Virgin Islands, British", code: "VG" },
  { name: "Virgin Islands, U.S.", code: "VI" },
  { name: "Wallis and Futuna", code: "WF" },
  { name: "Western Sahara", code: "EH" },
  { name: "Yemen", code: "YE" },
  { name: "Zambia", code: "ZM" },
  { name: "Zimbabwe", code: "ZW" },
];

const countryOptions = CountryList.map((data) => ({
  value: data.code,
  label: data.name,
}));

//const ZOHO = window.ZOHO;
const AutoAddress = ({ state }) => {
  const google = window.google;
  const searchInput = "search_input";
  const [mapdata, setmapdata] = useState(false);
  //country set...
  const [SelectCountry, setSelectCountry] = useState();
  const CountrySelect = (e) => {
    setSelectCountry(e.target.value);
  };

  const defaultCountry = async () => {
    try {
      // Step 1: Get IP address
      const ipRes = await axios.get("https://api.ipify.org?format=json");
      const ipAddress = ipRes.data.ip;
      // console.log("ipAddress: " + ipAddress);

      // Step 2: Send to PHP server
      const res = await axios.post("https://apps.w3scloud.com/find-address-extension/get-country.php", {
        ip: ipAddress,
      });

      // Step 3: Get Location
      const rawString = res.data; // "callback({...})"
      // console.log("rawString: " + rawString);
      if (typeof rawString === "string" && rawString.startsWith("callback(")) {
        const jsonStr = rawString.slice(9, -1); // remove "callback(" and ending ")"
        const jsonData = JSON.parse(jsonStr); // convert to JS object
        const countrycode = jsonData.country_code;

        // console.log("Country code:", countrycode);
        setSelectCountry(countrycode);
      } else {
        console.error("Unexpected response format:", rawString);
      }
    } catch (err) {
      console.error("PHP API Error:", err);
    }
  };

  useEffect(() => {
    // const defaultCountry = async () => {
    //   const data = await axios.get(
    //     "https://geolocation-db.com/json/50ad4a90-fd5e-11ec-b463-1717be8c9ff1"
    //   );

    //   const countrycode = data?.data?.country_code;
    //   setSelectCountry(countrycode);
    //   //document.getElementById("selectcountry").defaultValue="BD";
    // };
    defaultCountry();
  }, []);

  //setting page link
  const ChangePageHandler = () => {
    state("Setting");
    // window.location.reload(false);
  };

  let valueMap = {};

  //storing the all needed data as a object from map component
  const [MapValues, SetMapValues] = useState({
    StreetFull: "",
    Street: "",
    StreetNumber: "",
    Neighborhood: "",
    ZIPCode: "",
    City: "",
    State: "",
    Country: "",
    Latitude: "",
    Longitude: "",
  });

  const getInput = () => {
    if (google !== undefined) {
      var autocomplete;
      autocomplete = new google.maps.places.Autocomplete(
        document.getElementById(searchInput),
        {
          types: ["geocode"],
          componentRestrictions: { country: SelectCountry },
        }
      );

      google.maps.event.addListener(autocomplete, "place_changed", function () {
        const near_place = autocomplete.getPlace();
        const place_Latitude = near_place.geometry.location.lat();
        SetMapValues((preValue) => ({ ...preValue, Latitude: place_Latitude }));
        const place_Longitude = near_place.geometry.location.lng();
        SetMapValues((preValue) => ({
          ...preValue,
          Longitude: place_Longitude,
        }));

        fillInAddress(near_place);
        //console.log("map values: ",MapValues);
        setmapdata(true);
      });
    }
  };

  const fillInAddress = (place) => {
    SetMapValues((preValue) => ({
      ...preValue,
      StreetFull: "",
      Street: "",
      StreetNumber: "",
      Neighborhood: "",
      ZIPCode: "",
      City: "",
      State: "",
      Country: "",
      Latitude: "",
      Longitude: "",
    }));

    for (const component of place.address_components) {
      const componentType = component.types[0];
      // eslint-disable-next-line
      switch (componentType) {
        case "street_number": {
          SetMapValues((preValue) => ({
            ...preValue,
            StreetNumber: component.short_name,
          }));
          break;
        }
        case "route": {
          SetMapValues((preValue) => ({
            ...preValue,
            StreetFull: component.long_name,
          }));
          SetMapValues((preValue) => ({
            ...preValue,
            Street: component.short_name,
          }));
          break;
        }
        case "postal_code": {
          SetMapValues((preValue) => ({
            ...preValue,
            ZIPCode: component.long_name,
          }));
          break;
        }
        case "locality": {
          SetMapValues((preValue) => ({
            ...preValue,
            City: component.long_name,
          }));
          break;
        }
        case "sublocality_level_1": {
          SetMapValues((preValue) => ({
            ...preValue,
            Neighborhood: component.long_name,
          }));
          break;
        }
        case "administrative_area_level_1": {
          SetMapValues((preValue) => ({
            ...preValue,
            State: component.short_name,
          }));
          break;
        }
        case "country": {
          SetMapValues((preValue) => ({
            ...preValue,
            Country: component.long_name,
          }));
          break;
        }
      }
    }
  };

  const SaveAddressUsingPopulate = () => {
    console.log("Map Valus object: ", MapValues.ZIPCode);
    if (Module === "Contacts") {
      valueMap[Contacts_City] = MapValues.City;
      valueMap[Contacts_State] = MapValues.State;
      valueMap[Contacts_Zip_Code] = MapValues.ZIPCode;
      valueMap[Contacts_Country] = MapValues.Country;
      valueMap[Contacts_Street] = MapValues.Street;
      valueMap[Contacts_Street_Number] = MapValues.StreetNumber;
      valueMap[Contacts_Neighborhood] = MapValues.Neighborhood;
      valueMap[Contacts_Latitude] = MapValues.Latitude;
      valueMap[Contacts_Longitude] = MapValues.Longitude;
      ZOHO.CRM.UI.Record.populate(valueMap).then(function (data) {
        ZOHO.CRM.UI.Popup.close();
      });
    } else if (Module === "Leads") {
      valueMap[Leads_City] = MapValues.City;
      valueMap[Leads_State] = MapValues.State;
      valueMap[Leads_Zip_Code] = MapValues.ZIPCode;
      valueMap[Leads_Country] = MapValues.Country;
      valueMap[Leads_Street] = MapValues.Street;
      valueMap[Leads_Street_Number] = MapValues.StreetNumber;
      valueMap[Leads_Neighborhood] = MapValues.Neighborhood;
      valueMap[Leads_Latitude] = MapValues.Latitude;
      valueMap[Leads_Longitude] = MapValues.Longitude;
      ZOHO.CRM.UI.Record.populate(valueMap).then(function (data) {
        console.log(data);
        ZOHO.CRM.UI.Popup.close();
      });
    } else if (Module === "Accounts") {
      valueMap[Accounts_City] = MapValues.City;
      valueMap[Accounts_State] = MapValues.State;
      valueMap[Accounts_Zip_Code] = MapValues.ZIPCode;
      valueMap[Accounts_Country] = MapValues.Country;
      valueMap[Accounts_Street] = MapValues.Street;
      valueMap[Accounts_Street_Number] = MapValues.StreetNumber;
      valueMap[Accounts_Neighborhood] = MapValues.Neighborhood;
      valueMap[Accounts_Latitude] = MapValues.Latitude;
      valueMap[Accounts_Longitude] = MapValues.Longitude;
      ZOHO.CRM.UI.Record.populate(valueMap).then(function (data) {
        ZOHO.CRM.UI.Popup.close();
      });
    } else if (Module === CustomModule1_ApiName) {
      valueMap[CustomModule1_City] = MapValues.City;
      valueMap[CustomModule1_State] = MapValues.State;
      valueMap[CustomModule1_Zip_Code] = MapValues.ZIPCode;
      valueMap[CustomModule1_Country] = MapValues.Country;
      valueMap[CustomModule1_Street] = MapValues.Street;
      valueMap[CustomModule1_StreetFull] = MapValues.StreetFull;
      valueMap[CustomModule1_Street_Number] = MapValues.StreetNumber;
      valueMap[CustomModule1_Neighborhood] = MapValues.Neighborhood;
      valueMap[CustomModule1_Latitude] = MapValues.Latitude;
      valueMap[CustomModule1_Longitude] = MapValues.Longitude;
      ZOHO.CRM.UI.Record.populate(valueMap).then(function (data) {
        ZOHO.CRM.UI.Popup.close();
      });
    } else if (Module === CustomModule2_ApiName) {
      valueMap[CustomModule2_City] = MapValues.City;
      valueMap[CustomModule2_State] = MapValues.State;
      valueMap[CustomModule2_Zip_Code] = MapValues.ZIPCode;
      valueMap[CustomModule2_Country] = MapValues.Country;
      valueMap[CustomModule2_Street] = MapValues.Street;
      valueMap[CustomModule2_StreetFull] = MapValues.StreetFull;
      valueMap[CustomModule2_Street_Number] = MapValues.StreetNumber;
      valueMap[CustomModule2_Neighborhood] = MapValues.Neighborhood;
      valueMap[CustomModule2_Latitude] = MapValues.Latitude;
      valueMap[CustomModule2_Longitude] = MapValues.Longitude;
      ZOHO.CRM.UI.Record.populate(valueMap).then(function (data) {
        ZOHO.CRM.UI.Popup.close();
      });
    }
  };

  const CancelButton = () => {
    setmapdata(false);
    document.getElementById("search_input").value = null;
    SetMapValues((preValue) => ({
      ...preValue,
      StreetFull: "",
      Street: "",
      StreetNumber: "",
      Neighborhood: "",
      ZIPCode: "",
      City: "",
      State: "",
      Country: "",
      Latitude: "",
      Longitude: "",
    }));
  };

  useEffect(() => {
    getInput();
  });

  return (
    <Container fluid>
      <Row style={{ marginTop: "7px" }}>
        <Col md={1} style={{ marginTop: "33px" }}>
          <Button
            variant="primary"
            className="setting-btn"
            style={{
              borderColor: "none",
              outline: "none",
              outlineColor: "#183153",
            }}
            onClick={ChangePageHandler}
          >
            <Settings
              style={{
                color: "white",
                fontSize: "21px",
                marginLeft: "4px",
                border: "none",
              }}
            />
          </Button>
        </Col>
        {/* select the country start*/}
        <Col md={3}>
          <Form.Label style={{ color: "#183153" }}>
            <span>
              <FontAwesomeIcon style={{ color: "#183153" }} icon={faFlag} />
            </span>
            &nbsp;Country
          </Form.Label>

          {SelectCountry ? (
            <Select
              id="selectcountry"
              options={countryOptions}
              value={countryOptions.find(option => option.value === SelectCountry)}
              onChange={(selectedOption) => CountrySelect({ target: { value: selectedOption.value } })}
              styles={{
                control: (base) => ({
                  ...base,
                  borderRadius: "0.75rem",
                  fontSize: "16px",
                }),
              }}
            />
            // <Form.Select
            //   id="selectcountry"
            //   size="sm"
            //   value={SelectCountry}
            //   style={{
            //     borderRadius: ".75rem",
            //     fontSize: "16px",
            //   }}
            //   onChange={CountrySelect}
            // >
            //   {CountryList.map((data) => (
            //     <option key={data?.code} value={data?.code}>{data?.name}</option>
            //   ))}
            // </Form.Select>
          ) : (
            <Form>
              <Button
                variant="primary"
                style={{
                  backgroundColor: "#183153",
                  padding: "7px",
                  outline: "0px",
                  border: "0px",
                  color: "white",
                }}
                disabled
              >
                <Spinner
                  as="span"
                  animation="grow"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
                Loading...
              </Button>
            </Form>
          )}
        </Col>
        {/* select the country end*/}

        <Col md={8}>
          <div className="searchbox">
            <div className="form-group">
              <label style={{ color: "#183153" }}>
                <FontAwesomeIcon
                  style={{ color: "#183153" }}
                  icon={faMapLocationDot}
                />
                &nbsp;Location
              </label>
              <input
                type="text"
                style={{
                  borderRadius: ".75rem",
                  fontSize: "18px",
                }}
                className="form-control"
                id="search_input"
                placeholder="Type address..."
              />
            </div>
          </div>
        </Col>
      </Row>

      {/* map data result */}
      {mapdata === true && (
        <Row
          style={{
            marginTop: "5px",
          }}
        >
          <Col md={2}></Col>
          <Col md={4}>
            <Card className="text-center">
              <Card.Body>
                <p style={{ fontSize: "18px" }}> Street Full </p>
                <footer
                  className="blockquote-footer"
                  style={{ fontSize: "15px" }}
                >
                  {MapValues.StreetFull}
                </footer>
                <hr />
                <p style={{ fontSize: "18px" }}> Street </p>
                <footer
                  className="blockquote-footer"
                  style={{ fontSize: "15px" }}
                >
                  {MapValues.Street}
                </footer>
                <hr />
                <p style={{ fontSize: "18px" }}> Street Number </p>
                <footer
                  className="blockquote-footer"
                  style={{ fontSize: "15px" }}
                >
                  {MapValues.StreetNumber}
                </footer>
                <hr />
                <p style={{ fontSize: "18px" }}> Zip Code/Postal Code </p>
                <footer
                  className="blockquote-footer"
                  style={{ fontSize: "15px" }}
                >
                  {MapValues.ZIPCode}
                </footer>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4}>
            <Card className="text-center">
              <Card.Body>
                <p style={{ fontSize: "18px" }}> City </p>
                <footer
                  className="blockquote-footer"
                  style={{ fontSize: "15px" }}
                >
                  {MapValues.City}
                </footer>
                <hr />
                <p style={{ fontSize: "18px" }}> State </p>
                <footer
                  className="blockquote-footer"
                  style={{ fontSize: "15px" }}
                >
                  {MapValues.State}
                </footer>
                <hr />
                <p style={{ fontSize: "18px" }}> Country </p>
                <footer
                  className="blockquote-footer"
                  style={{ fontSize: "15px" }}
                >
                  {MapValues.Country}
                </footer>
              </Card.Body>
            </Card>
          </Col>
          <Col md={2}></Col>
        </Row>
      )}
      {mapdata === true && (
        <Row style={{ marginTop: "10px" }}>
          <Col md={2}></Col>
          <Col>
            <Card className="text-center">
              <Card.Body>
                <Button
                  variant="secondary"
                  onClick={CancelButton}
                  style={{
                    fontSize: "15px",
                    marginRight: "10px",

                    // color: "#495057",
                    // backgroundColor: "#fff",
                    // borderColor: "#80bdff",
                    // outline: "0",
                    // boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)"
                  }}
                >
                  Clear
                </Button>{" "}
                <Button
                  variant="primary"
                  style={{ fontSize: "15px", backgroundColor: "#183153", border: '0px', outline: '0px' }}
                  onClick={SaveAddressUsingPopulate}
                >
                  Save
                </Button>
                {' '}
                {' '}
                {/* <Button variant="primary" style={{fontSize:"15px",}} onClick={()=>console.log(MapValues)}>Testing</Button> */}
              </Card.Body>
            </Card>
          </Col>
          <Col md={2}></Col>
        </Row>
      )}
    </Container>
  );
};
export default AutoAddress;

//npm install --save react-places-autocomplete
//npm install
